import React, { useState, useEffect } from 'react';
import { ReactComponent as FileIcon } from 'assets/icons/file-icon.svg';
import AddTeamManually, { defaultData } from './add-team-manually';
import AddCsvFile, { FileDetailsType } from './add-csv-file';
import { AddIcon } from 'cokitchen-icons';
import useGetStartedActionsContext from 'contexts/get-started-actions.context';
import * as XLSX from 'xlsx';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { getJsDateFromExcel } from 'excel-date-to-js';
import { handleApiError } from 'utils/functions';
import { DepartmentType } from 'models/department.model';

export type ActiveType = 'xls' | 'manual';
const AddYourTeam = () => {
  const { activeCompany } = useDashboardContext();
  const companyId = activeCompany?.id;
  const { setIsDisabled, teamDataForm, setTeamDataForm, isFormEmpty, active, setActive } =
    useGetStartedActionsContext();
  const [file, setFile] = useState<File | null>(null);
  const [departmentOptions, setDepartmentOptions] = useState<DepartmentType[]>([]);

  useEffect(() => {
    setIsDisabled(!active);
  }, [active]);
  const fetchDepartment = async () => {
    if (!companyId) return;
    try {
      const res = await apiService.get(`department/company/${companyId}`);
      setDepartmentOptions(
        res?.data?.data?.map((d: DepartmentType) => ({ id: d.name, name: d.name }))
      );
    } catch (err) {
      handleApiError(err);
    }
  };
  useEffect(() => {
    fetchDepartment();
  }, []);

  const readFile = () => {
    if (file) {
      const reader = new FileReader();
      reader.readAsBinaryString(file);
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const data = e.target?.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const fileDetails = workbook.SheetNames[0];

        const headers: string[] = (
          XLSX.utils.sheet_to_json(workbook.Sheets[fileDetails], { header: 1 })[0] as string[]
        ).map((header: string) => header.toLowerCase().replace(/ /g, '_'));

        let convertMemberDetails = XLSX.utils.sheet_to_json(workbook.Sheets[fileDetails], {
          header: headers
        });

        convertMemberDetails = convertMemberDetails.slice(1);
        convertMemberDetails = convertMemberDetails.map((member: any) => {
          const currMember = member;
          const dob =
            typeof currMember.dob === 'number' ? getJsDateFromExcel(currMember.dob) : undefined;
          delete currMember.dob;
          delete currMember['s/n'];
          return {
            ...currMember,
            dob,
            phone_number: String(currMember.phone_number),
            budget: String(currMember.budget),
            role: currMember.role.toUpperCase()
          };
        });
        const newDepartments = convertMemberDetails.reduce((departments: any[], member: any) => {
          if (
            member.department &&
            !departmentOptions.find((d) => d.name === member.department) &&
            !departments.find((d) => d.name === member.department)
          )
            departments.push({ id: member.department, name: member.department });
          return departments;
        }, []);
        if (newDepartments.length) setDepartmentOptions(departmentOptions.concat(newDepartments));
        setTeamDataForm(convertMemberDetails as FileDetailsType[]);
      };
    }
  };
  useEffect(() => {
    readFile();
  }, [file]);
  return (
    <div className='flex flex-col max-w-[390px] w-full mx-auto'>
      <h2 className='text-2xl font-bold'>Add your team</h2>
      <p className='text-[#6F7376] text-sm mt-2'>
        Ensure the details provided here is the same as that used to register/signin to the
        FoodCourt App
      </p>

      <div className='flex gap-4 my-6 flex-wrap sm:flex-nowrap'>
        <AddCsvFile
          setFile={setFile}
          setFileDetails={setTeamDataForm}
          fileDetails={teamDataForm}
          active={active}
          setActive={setActive}
          isFormEmpty={isFormEmpty}
          formType='members'
        />
        <button
          disabled={!isFormEmpty}
          onClick={() => {
            setActive('manual');
            setTeamDataForm([defaultData]);
          }}
          className={`border ${
            active === 'manual'
              ? 'border-[#E60A2B] cursor-not-allowed'
              : 'border-[#EAEBEB] hover:border-[#E60A2B]'
          } hover:border-[1.5px] w-full sm:w-[185px] h-[139px] p-2 sm:p-4 rounded-md cursor-pointer space-y-3 flex flex-col`}>
          <div className='border border-[#EAEBEB] p-2 rounded-full  w-9 h-9 flex items-center'>
            <FileIcon />
          </div>
          <h2 className='text-sm font-semibold'>Add manually</h2>
          <p className='text-[#6F7376] text-xs font-normal text-start '>
            Add multiple members of your team
          </p>
        </button>
      </div>

      {active && <AddTeamManually departmentOptions={departmentOptions} />}

      {active === 'manual' && (
        <div
          className='text-[#0080E5] flex items-center gap-[2px] text-sm font-medium cursor-pointer my-4'
          onClick={() => setTeamDataForm([...teamDataForm, defaultData])}>
          <AddIcon className='w-5 h-5' />
          <span>Add Member</span>
        </div>
      )}
    </div>
  );
};

export default AddYourTeam;
